import React from 'react';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import StartNetworkingStep from '../../../StartNetworkingStep/StartNetworkingStep';
import {useEvent} from '../../../../../../data/hooks/eventHooks';

function StepSubscribeCategory(props) {
    const {eventId} = props,
        i18n = useI18n(),
        event = useEvent(eventId),
        {question_categories: categories} = event;

    return (
        <StartNetworkingStep href={['/events', eventId, 'qa', 'all', 'categories'].join('/')} visible={categories.length > 0}>
            {i18n['start.subscribe_category']}
        </StartNetworkingStep>
    );
}

export default StepSubscribeCategory;
